const addToCart = {
    init() {
        this.buttonOperations();
        this.afterAddToCart();
        
        jQuery('body').on('updated_cart_totals', function(){
            addToCart.buttonOperations()
        });
    },
    resetVariationInput(addToCart, quantityInput, initialText) {
        addToCart.classList.add('disabled');
        addToCart.textContent = initialText;
        quantityInput.value = 1;
    },
    buttonOperations() {
        const isProduct = document.querySelector('.single-product, .woocommerce-cart-form__cart-item, .tax-product_cat, .search .products');

        const products = document.querySelectorAll('.product-cart-container, .cart_item');
        const variations = document.querySelector('.variations_form');

        if ( ! isProduct ) return;

        if ( variations ) {
            const addToCart = document.querySelector('.ajax_add_to_cart');
            const quantityInput = document.querySelector('.add-to-cart__input');
            const select = document.querySelector('.variations_form select');
            const reset = document.querySelector('.reset_variations');

            const addToCartText = addToCart.getAttribute('data-add-to-text');
            const outOfStockText = addToCart.getAttribute('data-out-of-stock-text');
            const selectFromOptionsText = addToCart.getAttribute('data-select-option-text');

            jQuery( document ).on( "found_variation.first", function ( e, variation ) {
                if ( ! variation.is_in_stock ) {
                    addToCart.classList.add('disabled')
                    addToCart.textContent = outOfStockText;
                } else {
                    addToCart.classList.remove('disabled')
                    addToCart.textContent = addToCartText;
                }

                const maxQty = variation.max_qty;

                if ( maxQty ) {
                    quantityInput.setAttribute('max', maxQty);
                    if ( quantityInput.value > maxQty ) {
                        quantityInput.value = maxQty;
                        addToCart.setAttribute('data-quantity', maxQty);
                    }
                } else {
                    quantityInput.setAttribute('max', '');
                }

                addToCart.setAttribute('data-product_id', variation.variation_id);
                addToCart.setAttribute('value', variation.variation_id);
            } );

            reset.addEventListener('click', () => {
                this.resetVariationInput(addToCart, quantityInput, selectFromOptionsText);
            })

            if ( ! select.value ) {
                this.resetVariationInput(addToCart, quantityInput, selectFromOptionsText);
            }

            select.addEventListener('input', (e) => {
                if ( ! e.target.value ) {
                    this.resetVariationInput(addToCart, quantityInput, selectFromOptionsText);
                } else {
                    addToCart.textContent = addToCartText;
                }
            })

        }

        [...products, variations].forEach(product => {
            if ( ! product ) return;
            const subtractButton = product.querySelector(".add-to-cart__btn-subtract");
            const addButton = product.querySelector(".add-to-cart__btn-add");
            const quantityInput = product.querySelector(".add-to-cart__input");
            const addToCartButton = product.querySelector(".add_to_cart_button");

            subtractButton?.addEventListener("click", () => {
                let currentValue = parseInt(quantityInput.value) || 0;
                let minValue = quantityInput.getAttribute('min');
    
                if (currentValue > minValue) {
                    quantityInput.value = currentValue - 1;
    
                    this.updateDataQuantity(quantityInput, addToCartButton);
                }
    
                this.clickAnimation(subtractButton);
            });
            
            addButton?.addEventListener("click", () => {
                let currentValue = parseInt(quantityInput.value) || 0;
                let maxValue = parseInt(quantityInput.getAttribute("max")) || Infinity;
                
                if (currentValue < maxValue) {
                    quantityInput.value = currentValue + 1;
    
                    this.updateDataQuantity(quantityInput, addToCartButton);
                }
    
                this.clickAnimation(addButton);
            });
            
            quantityInput?.addEventListener("input", () => {
                let minValue = parseInt(quantityInput.getAttribute("min")) || 1;
                let maxValue = parseInt(quantityInput.getAttribute("max")) || Infinity;
                let value = parseInt(quantityInput.value.replace(/\D/g, '')) || minValue;
                
                if (value < minValue) quantityInput.value = minValue;
                if (value > maxValue) quantityInput.value = maxValue;
                
                this.updateDataQuantity(quantityInput, addToCartButton);
            });
            
            quantityInput?.addEventListener("keypress", function (event) {
                if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                }
            });
        });
    },
    updateDataQuantity(quantityInput, addToCartButton) {
        if (addToCartButton) {
            addToCartButton.setAttribute("data-quantity", quantityInput.value);
        }
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));

        // If we want auto-update
        // document.querySelector('.cart_update').click();
    },
    clickAnimation(button) {
        button.classList.add("clicked");

        setTimeout(() => {
            button.classList.remove("clicked");
        }, 150);
    },
    afterAddToCart() {
        const popup = document.querySelector('.add-to-cart-popup');
        const loader = document.querySelector('.loader-custom');
        const communicat = document.querySelector('.communicat');
        const failed = document.querySelector('.add-to-cart-failed');
        const success = document.querySelector('.add-to-cart-success');

        if ( !popup ) return;

        jQuery('body').on('adding_to_cart', function(event, ) {
            popup.classList.add('active');
            loader.classList.add('active');
        });

        jQuery('body').on('added_to_cart', function(event, fragments, cart_hash, button) {
            loader.classList.remove('active');
            communicat.classList.add('active');

            if ( cart_hash ) {
                const productName = button[0]?.getAttribute('data-product-name');
                const productNameLoader = document.querySelector('.loader-product-name');

                productNameLoader.textContent = productName;
                success.classList.add('active')
            } else {
                failed.classList.add('active')
            }

            setTimeout(() => {
                failed.classList.remove('active');
                success.classList.remove('active');
                loader.classList.remove('active');
                communicat.classList.remove('active');
                popup.classList.remove('active');
            }, 1500)

            popup.addEventListener('click', () => {
                popup.classList.remove('active');
            })
        });
    }
}

if (document.readyState === 'loading') { 
    document.addEventListener('DOMContentLoaded', () => addToCart.init()); 
  } else { 
    addToCart.init()
}
